export { useGetDecarbonizationPotential } from './useGetDecarbonizationPotential';
